module.exports = __webpack_public_path__ + "static/media/PricingWorkspaceStep6.277a8858.jpg";